


























































import { defineComponent, ref } from '@vue/composition-api';
import { Location as SLocation, Sample, Sampling } from '@/store/types';

export default defineComponent({
	props: {
		samplesByLocation: {
			type: Object as () => { [key: string]: Sample },
			required: true,
		},
		samplingsByLocation: {
			type: Object as () => { [key: string]: Sampling },
			required: true,
		},
		locationsById: {
			type: Object as () => { [key: string]: SLocation },
			required: true,
		},
	},
	setup() {
		const exportMenuIsVisible = ref(false);
		return {
			exportMenuIsVisible,
		};
	},
});
